module.exports = __webpack_public_path__ + "img/modify.0e40fd3e.svg";